"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapKeysDeep = exports.mapValuesAsync = exports.keysByValue = void 0;
const lodash_1 = require("lodash");
function keysByValue(object, value) {
    const valueFunc = typeof value !== "function"
        ? (objectValue) => objectValue === value
        : value;
    return Object
        .entries(object !== null && object !== void 0 ? object : [])
        .filter(([_, v]) => valueFunc(v))
        .map(([key]) => key);
}
exports.keysByValue = keysByValue;
exports.mapValuesAsync = async (obj, asyncFn) => {
    const results = await Promise.all(Object.entries(obj).map(([key, value]) => asyncFn(value, key).then(newValue => ({ key, value: newValue }))));
    return results.reduce((prev, { key, value }) => {
        prev[key] = value;
        return prev;
    }, {});
};
function mapKeysDeep(obj, cb) {
    if (Array.isArray(obj)) {
        return lodash_1.map(obj, innerObj => mapKeysDeep(innerObj, cb));
    }
    return lodash_1.isPlainObject(obj)
        ? lodash_1.mapValues(lodash_1.mapKeys(obj, cb), value => mapKeysDeep(value, cb))
        : obj;
}
exports.mapKeysDeep = mapKeysDeep;
//# sourceMappingURL=object.js.map